module.exports = ".wishlist .thumbnail {\n  max-height: 80px;\n  display: inline;\n}\n\n.wishlist .details {\n  display: inline;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Styles/nav.css
// module id = ./src/app/Styles/nav.css
// module chunks = main